import { DATE_FORMATS_FNS } from "components";
import { typedQueryClient, useTypedMutation } from "hooks";
import { LeadsQueryKeys } from "modules/LeadsDashboard/queryKeys";
import { ApiInstance } from "utils/Api";
import { formatCurrentUTCDate } from "utils/dateHelperFunctions";

import type { Snooze } from "models";

export const useNotSnoozedAppendSnoozeMutation = () =>
  useTypedMutation<Snooze, number>({
    mutationFn: async payload => (await ApiInstance.post("/snoozes/append", payload)).data.id,
    onSuccess: (payload, snoozeId) => {
      const notSnoozedLeads = typedQueryClient.getQueryData(LeadsQueryKeys.listNotSnoozed);
      if (!notSnoozedLeads?.items?.length) return;

      const snoozeIdx = notSnoozedLeads.items.findIndex(i =>
        payload.intervention_id ? i.intervention_id === payload.intervention_id : i.question_result_id === payload.question_result_id
      );
      if (snoozeIdx === -1) return;

      const snoozedItem = notSnoozedLeads.items[snoozeIdx];
      const updatedSnooze = { ...snoozedItem, ...payload, id: snoozeId, snooze_date: formatCurrentUTCDate(DATE_FORMATS_FNS.ISOFormat) };
      const updatedItem = payload.intervention_id
        ? {
            ...updatedSnooze,
            intervention: snoozedItem.intervention
              ? { ...snoozedItem.intervention, snooze_history: [updatedSnooze, ...(snoozedItem.intervention.snooze_history ?? [])] }
              : snoozedItem.intervention
          }
        : {
            ...updatedSnooze,
            question_result: snoozedItem.question_result
              ? { ...snoozedItem.question_result, snooze_history: [updatedSnooze, ...(snoozedItem.question_result.snooze_history ?? [])] }
              : snoozedItem.question_result
          };

      typedQueryClient.setQueryData(LeadsQueryKeys.listNotSnoozed, {
        ...notSnoozedLeads,
        items: notSnoozedLeads.items.with(snoozeIdx, updatedItem),
        nb_items: notSnoozedLeads.nb_items - 1
      });

      const snoozedLeads = typedQueryClient.getQueryData(LeadsQueryKeys.listSnoozed);
      if (!snoozedLeads) return;

      typedQueryClient.setQueryData(LeadsQueryKeys.listSnoozed, {
        ...snoozedLeads,
        items: [...(snoozedLeads.items ?? []), { ...payload, id: snoozeId }],
        nb_items: snoozedLeads.nb_items + 1
      });
    }
  });
